export * from './lib/environment';
export { EnvironmentLocalesEnum } from './lib/environment.interface';
